import sanityClientConstructor from '@sanity/client';

export const sanityProjectId = 'imd5394n';
export const sanityDataset = 'production';
export const sanityImagesBaseUrl = 'https://cdn.sanity.io/images';

export const sanityClient = sanityClientConstructor({
  projectId: sanityProjectId,
  dataset: sanityDataset,
  apiVersion: '2021-04-13', // use current UTC date - see "specifying API version"!
  //token: '', // or leave blank for unauthenticated usage
  useCdn: true // `false` if you want to ensure fresh data
});
